import React from "react";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { useState } from "react";
import listIcon from "../../../../assets/img/list.svg";
import { ReactComponent as Reopen } from "../../../../assets/img/corner-up-right_new.svg";
import contact from "../../../../assets/img/contact.svg";
import minusCircleRightIcon from "../../../../assets/img/minus-circle-light.svg";

export const SalesRow = ({
  IndividualSalesDetail,
  viewUser,
  handleUpdateStatus,
  onExpand,
}) => {
  const statusBackground = {
    completed: "#EBFBE8",
    acknowledged: "#FBF1E8",
    reopened: "#E7EEF6",
    canceled: "#FFE9E9",
    "in process": "#FFFDE5",
  };
  const statusTextColor = {
    completed: "#3AD219",
    acknowledged: "#D27119",
    reopened: "#0F51A1",
    canceled: "#FF2323",
    "in process": "#E2D100",
  };
  const [salesEdit, setGeneralEdit] = useState(IndividualSalesDetail);

  const status = salesEdit?.status?.toLocaleLowerCase();

  return (
    <tr>
      <td>
        <div
          className="icon_faqsBox"
          style={{ paddingLeft: "28px", color: "#000" }}
        >
          {salesEdit?.request_id}
        </div>
      </td>
      <td>
        <div
          style={{
            width: "100%",
            whiteSpace: "normal",
          }}
        >
          <div>{salesEdit?.name}</div>
          <div>{salesEdit?.email}</div>
        </div>
      </td>
      <td className="pre-desc">
        {IndividualSalesDetail?.details &&
        IndividualSalesDetail?.details.length <= 100 ? (
          IndividualSalesDetail?.details
        ) : (
          <p className="mb-0">
            {IndividualSalesDetail.isExpand
              ? IndividualSalesDetail?.details
              : IndividualSalesDetail?.details.substr(0, 100)}
            <span className="bold-desc cursor-pointer" onClick={onExpand}>
              {!IndividualSalesDetail.isExpand
                ? "...Read More"
                : "...Read less"}
            </span>
          </p>
        )}
      </td>
      <td>
        <div
          style={{
            width: "100%",
            whiteSpace: "normal",
          }}
        >
          {`${salesEdit?.assignStaffId?.first_name} ${salesEdit?.assignStaffId?.last_name}`}
        </div>
      </td>
      <td>
        <div
          style={{
            width: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            overflowWrap: "break-word",
            background: statusBackground[status],
            color: statusTextColor[status],
            padding: "5px",
            borderRadius: "6px",
            textAlign: "center",
          }}
        >
          {salesEdit?.status}
        </div>
      </td>

      <td className="switchBox">
        <div
          className="d-flex align-items-start justify-content-end"
          style={{
            width: "100%",
          }}
        >
          <button className="btn btn-secondary th-btn" onClick={viewUser}>
            {" "}
            <img src={listIcon} alt="" /> View{" "}
          </button>
          <Button
            className="btn btn-secondary th-btn edit-tb action-block-btn"
            onClick={() => {
              if (salesEdit?.phone) {
                window.open(`tel:${salesEdit?.phone}`);
              } else if (salesEdit?.email) {
                window.open(`mailto:${salesEdit?.email}`);
              } else {
                toast.info("There is no any contact details.");
              }
            }}
          >
            <span>
              <img src={contact} alt="" className={"img-main"} />
              <img src={contact} alt="" className={"img-hover"} />
            </span>
            Contact
          </Button>
          <Button
            variant={salesEdit?.status !== "Completed" ? "danger" : ""}
            className={`${
              salesEdit?.status !== "Completed" ? "delete-tb" : ""
            } btn th-btn  action-block-btn reopen-main-container`}
            onClick={() => {
              if (
                salesEdit?.status === "Completed" ||
                salesEdit?.status === "Canceled"
              ) {
                handleUpdateStatus("Reopened", salesEdit?._id);
              } else {
                handleUpdateStatus("Canceled", salesEdit?._id);
              }
            }}
          >
            <span className="child-repoen-span">
              {salesEdit?.status == "Completed" ||
              salesEdit?.status == "Canceled" ? (
                <Reopen />
              ) : (
                <img src={minusCircleRightIcon} alt="" />
              )}
            </span>
            {salesEdit?.status == "Completed" || salesEdit?.status == "Canceled"
              ? "Reopen"
              : "Cancel"}
          </Button>
        </div>
      </td>
    </tr>
  );
};
